/**
 * Created by i.lovenkov on 29.11.16.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _reactRouter = require('react-router');

var _CSSTransitionGroup = require('react-transition-group/CSSTransitionGroup');

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

var _components2 = require('components');

var _MobileCatalog = require('../MobileCatalog/MobileCatalog');

var _MobileCatalog2 = _interopRequireDefault(_MobileCatalog);

var _MyMenu = require('../MyMenu/MyMenu');

var _MyMenu2 = _interopRequireDefault(_MyMenu);

require('./Hamburger.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    HamburgerView: {
        displayName: 'HamburgerView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Hamburger/default/HamburgerView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var HamburgerView = _wrapComponent('HamburgerView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(HamburgerView, _Component);

    function HamburgerView(props) {
        (0, _classCallCheck3.default)(this, HamburgerView);

        var _this = (0, _possibleConstructorReturn3.default)(this, (HamburgerView.__proto__ || (0, _getPrototypeOf2.default)(HamburgerView)).call(this, props));

        _this.handleClick = function () {
            _this.props.close();
        };

        return _this;
    }

    (0, _createClass3.default)(HamburgerView, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                categories = _props.categories,
                hamburgerClass = _props.hamburgerClass,
                logo = _props.logo,
                phone = _props.phone,
                pages = _props.pages,
                title = _props.title,
                showCatalog = _props.showCatalog,
                user = _props.user,
                lang = _props.lang;

            var name = '';

            if (user) {
                name = user.name || user.phone || user.email || '';
            }

            var hamburgerBody = null;
            switch (showCatalog) {
                case 'catalog':
                    hamburgerBody = _react3.default.createElement(_MobileCatalog2.default, {
                        handleClick: this.handleClick,
                        handleBackClick: this.props.handleBackClick,
                        title: lang['store.hamburger.catalog'],
                        categories: categories,
                        key: "catalog"
                    });
                    break;
                case 'menu':
                    hamburgerBody = _react3.default.createElement(_MyMenu2.default, {
                        handleClick: this.handleClick,
                        handleBackClick: this.props.handleBackClick,
                        logout: this.props.logout,
                        key: "menu",
                        lang: lang
                    });
                    break;
                default:
                    hamburgerBody = _react3.default.createElement(
                        'div',
                        { key: 'default' },
                        _react3.default.createElement(_components2.Logo, { onClick: this.handleClick, logo: logo, imgClassName: 'hamburger_logo' }),
                        _react3.default.createElement(
                            'h2',
                            null,
                            title
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'registration' },
                            user ? _react3.default.createElement(
                                'div',
                                { className: 'registration_item', onClick: this.props.handleMyMenuClick },
                                _react3.default.createElement('i', { className: 'fa fa-user-o prev_icon' }),
                                _react3.default.createElement(
                                    'span',
                                    null,
                                    name
                                ),
                                _react3.default.createElement(_components2.Notification, { iconClassName: 'hamburger_warning_icon' }),
                                _react3.default.createElement('i', { className: 'fa fa-chevron-right post_icon' })
                            ) : _react3.default.createElement(
                                'div',
                                { className: 'registration_item', onClick: function onClick() {
                                        return _this2.props.handleAuthClick(lang);
                                    } },
                                _react3.default.createElement('i', { className: 'fa fa-sign-in prev_icon' }),
                                _react3.default.createElement(
                                    'span',
                                    null,
                                    lang['login.logIn']
                                )
                            ),
                            !user ? _react3.default.createElement(
                                'div',
                                { className: 'registration_item', onClick: function onClick() {
                                        return _this2.props.handleRegisterClick(lang);
                                    } },
                                _react3.default.createElement('i', { className: 'fa fa-user-plus prev_icon' }),
                                _react3.default.createElement(
                                    'span',
                                    null,
                                    lang['store.register.register']
                                )
                            ) : null
                        ),
                        _react3.default.createElement(
                            'ul',
                            { className: 'hamburger_list' },
                            _react3.default.createElement(
                                'li',
                                null,
                                _react3.default.createElement(
                                    'a',
                                    { href: '#', onClick: this.props.handleCatalogClick },
                                    _react3.default.createElement(
                                        'span',
                                        null,
                                        lang['store.hamburger.catalog']
                                    ),
                                    _react3.default.createElement('i', { className: 'fa fa-chevron-right post_icon' })
                                )
                            ),
                            _react3.default.createElement(
                                'li',
                                null,
                                _react3.default.createElement(
                                    _reactRouter.Link,
                                    { to: '/', onClick: this.handleClick },
                                    _react3.default.createElement(
                                        'span',
                                        null,
                                        lang['store.hamburger.main']
                                    )
                                )
                            ),
                            pages.map(function (page, index) {
                                return _react3.default.createElement(
                                    'li',
                                    { key: index },
                                    _react3.default.createElement(
                                        _reactRouter.Link,
                                        { to: '/page/' + page.url, onClick: _this2.handleClick },
                                        _react3.default.createElement(
                                            'span',
                                            null,
                                            page.title
                                        )
                                    )
                                );
                            })
                        )
                    );
            }

            return _react3.default.createElement(
                'div',
                { className: hamburgerClass },
                _react3.default.createElement(
                    'div',
                    { className: 'hamburger_container' },
                    _react3.default.createElement('span', { className: 'fa fa-times close_button', onClick: this.handleClick }),
                    _react3.default.createElement(
                        _CSSTransitionGroup2.default,
                        { transitionName: showCatalog ? "slide_to_left" : "slide_to_right",
                            transitionEnterTimeout: 300,
                            transitionLeaveTimeout: 300 },
                        hamburgerBody
                    )
                )
            );
        }
    }]);
    return HamburgerView;
}(_react2.Component), _class.propTypes = {
    hamburgerClass: _react2.PropTypes.string.isRequired,
    logo: _react2.PropTypes.string.isRequired,
    phone: _react2.PropTypes.string,
    title: _react2.PropTypes.string.isRequired,
    lang: _react2.PropTypes.object
}, _temp));

exports.default = HamburgerView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Hamburger/default/HamburgerView.jsx
// module id = 1672
// module chunks = 0